import { cn } from "@/lib/utils";

interface RiskGaugeProps {
  score: number;
  className?: string;
}

export function RiskGauge({ score, className }: RiskGaugeProps) {
  const color = score < 40 ? "#22c55e" : score < 70 ? "#F5F10B" : "#FF281D";
  const r = 38;
  const c = 2 * Math.PI * r;
  const dash = (score / 100) * c;

  return (
    <div className={cn("grid size-24 place-items-center", className)}>
      <svg
        width="96"
        height="96"
        viewBox="0 0 96 96"
        className="col-start-1 row-start-1 -rotate-90"
        aria-hidden="true"
      >
        <circle cx="48" cy="48" r={r} stroke="currentColor" strokeWidth="6" fill="none" className="text-muted" />
        <circle
          cx="48"
          cy="48"
          r={r}
          stroke={color}
          strokeWidth="6"
          fill="none"
          strokeDasharray={`${dash} ${c}`}
          strokeLinecap="round"
          className="transition-all duration-500"
        />
      </svg>
      <div className="col-start-1 row-start-1 flex flex-col items-center justify-center">
        <span className="font-mono text-2xl font-semibold" style={{ color }}>
          {score}
        </span>
        <span className="text-[9.5px] tracking-wide text-muted-foreground uppercase">Risk</span>
      </div>
    </div>
  );
}
